import { Options } from "canvas-confetti";

export const CONFETTI_TYPES: Record<string, Options> = {
    TOP_UP_COUPON: {
        particleCount: 200,
        spread: 180,
        origin: { y: -0.1 },
        startVelocity: -20,
        zIndex: 1000,
    },
    AUTO_APPLY_COUPON: {
        particleCount: 200,
        spread: 360,
        origin: { y: 0.3 },
        startVelocity: -20,
        zIndex: 9999,
    },
    APPLY_SWIGGY_ONE: {
        colors: ["#33A6D1", "#D133AF", "#EFDA34", "#8035DA", "#FFFFFF"],
        particleCount: 220,
        spread: 180,
        origin: { y: -0.1 },
        startVelocity: -20,
        shapes: ["square", "circle"],
    },
    APPLY_SWIGGY_BLACK: {
        colors: ["#9D8074", "#863779", "#C4B2A9", "#460C39", "#FFFFFF"],
        particleCount: 220,
        spread: 180,
        origin: { y: -0.1 },
        startVelocity: -20,
        shapes: ["square", "circle"],
    },
};
